import 'core-js/features/promise';
import 'core-js/features/array/includes';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/flat-map';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'core-js/features/number/is-nan';
import 'core-js/features/object/assign';
import 'core-js/features/array/fill';
import 'core-js/features/object/values';
import 'whatwg-fetch';
import 'core-js/features/object/entries';
import 'core-js/features/array/for-each';
import 'nodelist-foreach-polyfill';
import 'mdn-polyfills/Element.prototype.closest';
import 'custom-event-polyfill';

if (!Array.from) {
    Array.from = require('array-from');
}
